import { render } from "./TheInstructions.vue?vue&type=template&id=0282a2ad&scoped=true"
const script = {}

import "./TheInstructions.vue?vue&type=style&index=0&id=0282a2ad&scoped=true&lang=css"

import exportComponent from "/home/runner/work/kv-cloud-pbx/kv-cloud-pbx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0282a2ad"]])

export default __exports__